import type { FunnelId } from './config';
import type { FunnelConfig } from './funnelConfig';

export const BASELINE_CONFIG: FunnelConfig = {
  growthbookEnabled: true,
  quizVer: null,
  homeVer: null,
  homePageConfig: {
    titleKey: 'bl_newss1_title',
    censored: false,
    homePageVersion: null,
    loaderHomeVer: null,
    loaderTitles: null,
    useCustomInjectLoader: false,
  },
};

export const PRICING_FUNNEL_CONFIGS = {
  11: BASELINE_CONFIG,
  12: BASELINE_CONFIG,
  13: BASELINE_CONFIG,
  14: BASELINE_CONFIG,
  15: BASELINE_CONFIG,
  21: BASELINE_CONFIG,
  22: BASELINE_CONFIG,
  23: BASELINE_CONFIG,
  24: BASELINE_CONFIG,
  25: BASELINE_CONFIG,
  31: BASELINE_CONFIG,
  32: BASELINE_CONFIG,
  33: BASELINE_CONFIG,
  34: BASELINE_CONFIG,
  35: BASELINE_CONFIG,
} satisfies Partial<Record<FunnelId, FunnelConfig>>;
